import { useResourceContext } from 'react-admin'

// interface Options {
//   delete: boolean
//   revision: boolean
// }
// interface Permissions {
//   hasList?: boolean
//   hasCreate?: boolean
//   hasEdit?: boolean
//   hasShow?: boolean
// }

// interface PermissionsStore extends Permissions {
//   name?: string
//   options?: Options
// }

interface IHasPermission {
  children: JSX.Element[] | JSX.Element
  permission: string
  resource: string | null
  skip: boolean | null
}

// interface Module {
//   name: string
//   permission: {
//     entity: string
//     actions: {
//       action: string
//       menu: boolean
//     }[]
//   }[]
// }

function getPermission(resource: string, permission: string): boolean {
  const applicationString = localStorage.getItem('application')
  if (applicationString) {
    const application = JSON.parse(applicationString)

    const permissionMap: Record<string, string> = {
      hasEdit: 'edit',
      hasCreate: 'create',
      hasDelete: 'delete',
      hasList: 'list',
      hasShow: 'show',
    }

    const actualPermission = permissionMap[permission] || permission

    for (const module of application?.modules) {
      for (const perm of module.permission) {
        if (perm.entity === resource && perm.actions.some((a: any) => a.action === actualPermission)) {
          return true
        }
      }
    }
  }

  return false
}

export const HasPermission = ({ children, permission, resource = null, skip = false }: IHasPermission) => {
  const resourceName = useResourceContext()
  if (skip) return children
  if (getPermission(resource ? resource : resourceName, permission)) {
    return children
  }
  return null
}

export function hasPermissionFunction(resource: string, permission: string): boolean {
  // this work when component  must be inheritance parents style
  const applicationString = localStorage.getItem('application')
  if (applicationString) {
    const application = JSON.parse(applicationString)

    const permissionMap: Record<string, string> = {
      hasEdit: 'edit',
      hasCreate: 'create',
      hasDelete: 'delete',
      hasList: 'list',
      hasShow: 'show',
    }

    const actualPermission = permissionMap[permission] || permission

    for (const module of application?.modules) {
      for (const perm of module.permission) {
        if (perm.entity === resource && perm.actions.some((a: any) => a.action === actualPermission)) {
          return true
        }
      }
    }
  }

  return false
}
